module.exports = __webpack_public_path__ + "media/scheduleDemo/anthony1-68014068.png";